module.exports = __webpack_public_path__ + "media/images/frontend/heros/contacts-4ff13d534c90357ecd85f6d17b726f5b.jpg";